import { gql } from '@apollo/client';

import { MessageTypeMetadata } from './types';

export const USE_MESSAGE_TYPES_HOOK_QUERY = gql`
  query MessageTypesQuery {
    messageTypes {
      name
      id
    }
  }
`;

export const DEFAULT_MESSAGE_TYPES: MessageTypeMetadata[] = [];
